module.exports = __webpack_public_path__ + "img/C09E5C_DAD2B9_654429_81582D-256px.8879bcc9.png";